/** @jsx jsx */

import { Fragment as _, useMemo, useContext } from 'react';
import { css, jsx } from '@emotion/core';
import EditableText from 'components/lib/EditableText';
import renderBlock from 'services/apiHelpers/renderBlock';
import { Row, Column } from '@chameleoncreator/creator-ui';
import ContinueBtn from 'components/lib/ContinueBtn/continueBtn_v2';
import Image from 'components/lib/Image';
import Container from 'components/Layouts/ContainerLogical';
import { interactionContext as InteractionContext } from './interactionContext';
import Sortation from './Sortation';
import SortationHeading from './SortationHeading';
import getBlockById from 'services/apiHelpers/getBlockById';
import { Block } from '@chameleoncreator/creator-app';
import IELayout from 'components/Layouts/IELayout';
import Media, { MediaContext, IMediaContext } from 'components/lib/Media';
import Video from 'components/lib/Video';
import Transcript from 'components/lib/Video/Transcript';
import SVG from 'components/lib/SVG';
import Embed from 'components/lib/Embed';
import { findByKeyVal_V2 } from 'services/findByKeyVal';
import Media_default from 'assets/CC_Sortation_Placeholder.png';
import PDF from 'components/lib/PDF';
import { OpenPDF } from 'components/lib/PDF/OpenPDF';
import Audio from 'components/lib/Audio';
import { SortableImage } from './SortableImage';
import { imgPlaceholders } from 'components/lib/Image';

const SingleColumnLayout = Row.bind({}) as any;
SingleColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'column',
};

const TwoColumnLayout = Row.bind({}) as any;
TwoColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'row',
};

const Components = {
  Row,
  Column,
  Text: EditableText,
  InteractionColumn: ({ children }) => {
    return children?.[0] || null;
  },
  SortationQuestionText: ({ children, ...props }) => children,
  Image: ({ children, ...props }) => {
    // const updatedProps = {
    //   ...props,
    // };

    // if (!props.src) {
    //   updatedProps.placeholder = props.placeholder || Media_default;
    // }

    const mediaContext = useContext(MediaContext) as IMediaContext;
    const { isAdditionalMedia } = mediaContext;

    return (
      <Image
        {...{
          ...props,
          // ...updatedProps,
          placeholder: !isAdditionalMedia ? Media_default : imgPlaceholders[1],

          usePlaceholderValue: true,
        }}
      />
    );
    // return <Image {...{ ...updatedProps, usePlaceholderValue: true }} />;
    //
  },
  Video,
  Transcript,
  SVG,
  Embed,
  Media,
  TwoColumnLayout: TwoColumnLayout,
  SingleColumnLayout: SingleColumnLayout,
  ContinueButton: ContinueBtn,
  EditableButton: () => null,
  InteractionColumn: ({ children, ...props }) => {
    const interactionContext = useContext(InteractionContext);
    const { includeAdditionalTextField } = interactionContext.props;

    const [sortation, txt] = children;

    if (!includeAdditionalTextField) {
      return sortation;
    }

    return (
      <_>
        {sortation}
        <div
          style={{
            margin: '20px 0 0 0',
          }}
        >
          {txt}
        </div>
      </_>
    );
  },
  Sortation: ({ children, ...props }) => {
    // <div
    //   css={css`
    //     width: 100%;
    //   `}
    // >
    return <Sortation {...{ children, ...props }} />;
    // </div>
  },
  SortationHeading0: SortationHeading,
  SortationHeading1: SortationHeading,
  SortableImage,
  Answer: () => null,
  Feedback: ({ children }) => children,
  // Feedback: () => null,
  Correct: () => null,
  Incorrect: () => null,
  Attempt: () => null,
  PDF,
  OpenPDF,
  Audio,
  Modal: () => null,
};

const SortationDisplay = props => {
  const interactionBlock = getBlockById(props.blockId);

  const hasAttemptFeedback = findByKeyVal_V2(
    interactionBlock.id,
    'type',
    'Attempt'
  );

  const container = (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <InteractionContext.Provider
        value={{
          ...interactionBlock,
          updateItemsSeen: null,
          hasAttemptFeedback,
        }}
      >
        {(interactionBlock.children as Block[]).map(child => {
          return renderBlock(child, Components);
        })}
      </InteractionContext.Provider>
    </Container>
  );

  return window.dev()
    ? container
    : useMemo(() => {
        return container;
      }, [props.isOpen, interactionBlock.props!.lockDown]);
};

export default SortationDisplay;
